module.exports = __webpack_public_path__ + "static/media/legal.416cb546.md";